/* @flow */
import React from 'react';
import { graphql } from 'react-apollo';

import Text from 'components/Text';
import Heading from 'components/Heading';
import LoadingIndicator from 'components/LoadingIndicator';
import contentSourcesContentQuery from 'user/queries/contentSourcesContent.gql';
import EventTracking from 'lib/EventTracking';
import { mountModal } from 'lib/modal';
import LinkedContentPreviewModal from 'components/LinkedContentPreviewModal';
import AccountLinkingComposerSidebarContentItem from './AccountLinkingComposerSidebarContentItem';

type Props = {
  data: ReactApolloData<contentSourcesContentQuery>,
  contentSource: *,
  query: string,
  addLinkedContent: (*) => void,
  onQueryFailed: () => void,
};

class AccountLinkingComposerSidebarContentList extends React.Component<Props> {
  hovercardTriggers = [];

  renderItem = (item: *, index: number) => {
    const handleItemClicked = () => {
      if (index in this.hovercardTriggers) {
        this.hovercardTriggers[index].hideLayer();
      }
      const { contentSource, addLinkedContent } = this.props;
      EventTracking.trackKey('account_linking.browse_content.item.click', {
        provider: contentSource.providerKey,
        composer_version: 'web_modal',
      });

      if (item.contentUrl) {
        addLinkedContent(item);
      }
    };

    const handleThumbnailClicked = () => {
      if (index in this.hovercardTriggers) {
        this.hovercardTriggers[index].hideLayer();
      }
      mountModal(<LinkedContentPreviewModal linkedContent={item} />, this);
    };

    const registerHovercardTrigger = (trigger: *) => {
      this.hovercardTriggers[index] = trigger;
    };

    return (
      <AccountLinkingComposerSidebarContentItem
        key={index}
        item={item}
        handleItemClicked={handleItemClicked}
        handleThumbnailClicked={handleThumbnailClicked}
        registerHovercardTrigger={registerHovercardTrigger}
      />
    );
  };

  renderSection = (section: *, index: number) => {
    if (section.items.length === 0) {
      return null;
    }

    return (
      <div className="AccountLinkingComposerSidebarContent-section" key={index}>
        <Heading
          className="AccountLinkingComposerSidebarContent-section-title"
          level="2"
          levelStyle="3">
          <Text color="chalkboard">{section.sectionTitle}</Text>
        </Heading>
        {section.items.map(this.renderItem)}
      </div>
    );
  };

  render() {
    const { data, contentSource, query, onQueryFailed } = this.props;
    const { me, loading } = data;

    if (loading) {
      return (
        <LoadingIndicator
          className="AccountLinkingComposerSidebarServices-loading"
          align="center"
        />
      );
    }

    if (data.error || !me || !me.composer || !me.composer.contentSourcesContent) {
      onQueryFailed();

      return (
        <Text color="graphite" align="center">
          {`Failed to fetch ${contentSource.title} content. Please try again.`}
        </Text>
      );
    }
    if (me.composer.contentSourcesContent.length === 0) {
      if (query.length > 0) {
        return (
          <Text color="graphite" align="center">
            No results found
          </Text>
        );
      } else {
        return (
          <Text color="graphite" align="center">
            {`No content found on ${contentSource.title}`}
          </Text>
        );
      }
    }
    return <div>{me.composer.contentSourcesContent.map(this.renderSection)}</div>;
  }
}

const withContent = graphql(contentSourcesContentQuery, {
  options: ({ contentSource, query }) => ({
    fetchPolicy: 'network-only',
    variables: {
      source: contentSource.providerKey,
      query,
    },
  }),
});

export { AccountLinkingComposerSidebarContentList };
export default withContent(AccountLinkingComposerSidebarContentList);
